import AreaContainer from "../AreaContainer";
import styles from './financial.module.css';
import globalStyles from '../result.module.css';

interface Props {
    financialData: financialData[];
    ratesData: financialData[];
}

type financialData = {
    title: string,
    value: string | number
}

const FinancialDisplay = ({ financialData, ratesData }: Props) => {
    return (
        <AreaContainer area="financial" style={null} extraClass={null}>
            <div className={styles.InfomationWrapper}>
                <h2 className={globalStyles.subTitleText}>Financial</h2>
                {financialData.map((d, i) => {
                    return <div key={i}>
                        <h3 className={globalStyles.largeText} >{d.title}</h3>
                        <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`}  style={{ marginBottom: "1rem" }}>{d.value}</p>
                    </div>
                })}

                {ratesData.length > 0 && <div>
                    <h3 className={globalStyles.largeText} >Rates</h3>
                    <div className={styles.gridContainer}>
                        {ratesData.map((row, i) => {
                            return <div className={styles.gridRow} key={i}>
                                <div className={`${styles.gridCell} ${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{row.title}</div>
                                <div className={`${styles.gridCell} ${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{row.value}</div>
                            </div>
                        })}

                    </div>
                </div>}
            </div>
        </AreaContainer>
    );
}


export default FinancialDisplay;